<template>
    <div class="wrapper">
      <div class="main-slides h-70vh" style="background: url(img/mission_vision.jpg); background-size: cover;">
        <div class="page-header h-70vh">
          <div class="container">
            <div class="row align-items-center text-center text-light">
              <div class="col-lg-12 col-12" v-animate-onscroll="{down: 'animated fadeOutDown', up: 'animated fadeInDown' }">
                <h1 class="display-2 mt-8 text-light">
                    Proud Faces, Powerful Stories<span class="text-light">
                    Meet the Alumnis of Alpine Khurja.</span
                  >
                </h1>
                <a href="https://ags.univariety.com/user/alpinekhurja/login" target="_blank" class="btn btn-white btn-lg btn-round">Alumni Login</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section pt-5 pb-0">
        <div class="container-fluid px-0">
          <div class="row text-left justify-content-center">
            <div class="col-lg-12 col-12 mb-3">
                <iframe 
                    src="https://wg.univariety.com/widget/fe99beec-5631-481e-bc53-d7a4e99796a7"
                    title="Directory Stats" 
                    width="100%" 
                    height="500"
                    loading="lazy"
                    description="Alpine Public School, Khurja Alumni Statistics"
                    style="border: none; vertical-align: top"
                ></iframe>
            </div>
          </div>
        </div>
      </div>
      <!-- alumni section -->
        <div class="section my-0 pt-5 pb-5 bg-lighter border-top">
            <iframe 
                src="https://wg.univariety.com/widget/6eb0f242-1e29-4d92-b828-55066d27f3f6"
                title="Notable Alumni" 
                width="100%" 
                height="600px"
                loading="lazy"
                description="Building Futures, Honoring Legacies."
                style="border: none; vertical-align: top;"
                class="bg-lighter"
            ></iframe>
            <div class="container-fluid bg-lighter mt--5">
                <div class="row">
                <div class="col-lg-12 col-12 col-md-6 text-center">
                </div>
                </div>
            </div>
        </div>
        <!-- end alumni section -->
        
        <!-- alumni companies -->
        <div class="section my-0 pt-5 pb-0 border-top">
            <iframe 
                src="https://wg.univariety.com/widget/e8e09d56-62df-44cb-ae23-21938214ded4"
                title="Top Companies" 
                width="100%" 
                height="600px"
                loading="lazy"
                description="Our Alumni Work with Leading Companies Globally"
                style="border: none; vertical-align: top"
            ></iframe>
            <div class="container-fluid bg-lighter mt--5">
                <div class="row">
                <div class="col-lg-12 col-12 col-md-6 text-center">
                </div>
                </div>
            </div>
        </div>
        <!-- end alumni companies -->

        <!-- alumni career sectors -->
        <div class="section my-0 pt-5 pb-5 border-top">
            <iframe 
                src="https://wg.univariety.com/widget/7e3afcf7-7d7f-4698-ba5d-6a0787e241f3"
                title="Top Careers" 
                width="100%" 
                height="600px"
                loading="lazy"
                description="Most Popular Careers"
                style="border: none; vertical-align: top"
            ></iframe>
            <div class="container-fluid mt--5">
                <div class="row">
                <div class="col-lg-12 col-12 col-md-6 text-center">
                </div>
                </div>
            </div>
        </div>
    </div>
  </template>
  <script>
  
  import axios from "axios";
  export default {
    bodyClass: "key_features",
    components: {
    },
    data() {
      return {
        metaData:[],
        social_responsibility:[],
        items: [
          'img/results_bg.jpg',
          'img/physics_lab.jpg',
          'img/sports4.jpg',
          'img/school_bul.jpeg',
        ],
        index: null,
        auth : {
            headers: { 'Content-Type':'application/x-www-form-urlencoded',
            'Authorization':'alpine#' + localStorage.getItem('accessToken'),
            '_id':localStorage.getItem('_id')}
          },
          authjson : { headers: { 'Content-Type':'application/json',
            'Authorization':'alpine#' + localStorage.getItem('accessToken'),
            '_id':localStorage.getItem('_id')}
          },
      }
    },
    mounted () {          
            axios
            .post(process.env.VUE_APP_API_ENDPOINT+'read_social_responsibility',{ "details" :{},"offset":"0"},this.authjson)
            .then(response => {
              console.log(response);
              if(response.data.details){
                this.social_responsibility=response.data.details[0]; 
              }else{
                this.social_responsibility=[];
              }
            })
          // read meta api call
        axios
        .post(process.env.VUE_APP_API_ENDPOINT+'read_metadata',{ "details" :{"page_url":'/'},"offset":"0"},this.authjson)
        .then(response => {
          console.log(response);
          if(response.data.details){
          this.metaData=response.data.details[0];
            
          }else{
            this.metaData={};
          }
        })
    },
  };
  </script>
  <style>
  .key_features  .info-horizontal {
    max-width: 100% !important;
  }
  </style>
  